import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  provideTransloco,
  provideTranslocoLoader,
  provideTranslocoMissingHandler,
  Translation,
  TranslocoConfig,
  TranslocoLoader,
  TranslocoMissingHandler,
} from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { environment } from 'src/environments/environment';
import { computeMissingKey } from './i18n.service';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http: HttpClient;
  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@Injectable()
export class CustomTranslocoMissingHandler implements TranslocoMissingHandler {
  handle(key: string, config: TranslocoConfig) {
    if (config.missingHandler!.logMissingKey && !config.prodMode) {
      const msg = `Missing translation for '${key}'`;
      console.warn(`%c ${msg}`, 'font-size: 12px; color: red');
    }

    return computeMissingKey(key);
  }
}

export const translocoProviders = [
  provideTransloco({
    config: {
      availableLangs: ['en', 'fr'],
      defaultLang: 'fr',
      fallbackLang: 'fr',
      // Remove this option if your application doesn't support changing language in runtime.
      reRenderOnLangChange: true,
      prodMode: environment.enableAngularProdMode,
    },
  }),
  provideTranslocoMessageformat(),
  provideTranslocoLocale({
    langToLocaleMapping: {
      en: 'en-US',
      fr: 'fr-FR',
    },
  }),
  provideTranslocoLoader(TranslocoHttpLoader),
  provideTranslocoMissingHandler(CustomTranslocoMissingHandler),
];
